<template>
  <b-modal
    id="modal-privacy"
    :title="modalData.title"
    size="lg"
    hide-footer
    scrollable
  >
    <div v-html="modalData.content" />
  </b-modal>
</template>
<script>
import { BModal } from 'bootstrap-vue'

export default {
  name: 'PrivacyModal',
  components: {
    BModal,
  },
  computed: {
    modalData() {
      return this.$store.getters['contents/dataItem']('1')
    },
  },
  created() {
    this.getContent()
  },
  methods: {
    getContent() {
      this.$store.dispatch('contents/getDataItem', '1')
    },
  },
}
</script>
